module.exports = __webpack_public_path__ + "cheer.svg?10c8965bc238edd3dcc8a4e61c656e82";